/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FormateurHoraireIncoherenceGridDto } from './FormateurHoraireIncoherenceGridDto';
import {
    FormateurHoraireIncoherenceGridDtoFromJSON,
    FormateurHoraireIncoherenceGridDtoFromJSONTyped,
    FormateurHoraireIncoherenceGridDtoToJSON,
} from './FormateurHoraireIncoherenceGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FormateurHoraireIncoherenceGridDtoPaginatedResults
 */
export interface FormateurHoraireIncoherenceGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FormateurHoraireIncoherenceGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FormateurHoraireIncoherenceGridDto>}
     * @memberof FormateurHoraireIncoherenceGridDtoPaginatedResults
     */
    results?: Array<FormateurHoraireIncoherenceGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FormateurHoraireIncoherenceGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FormateurHoraireIncoherenceGridDtoPaginatedResults interface.
 */
export function instanceOfFormateurHoraireIncoherenceGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateurHoraireIncoherenceGridDtoPaginatedResultsFromJSON(json: any): FormateurHoraireIncoherenceGridDtoPaginatedResults {
    return FormateurHoraireIncoherenceGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FormateurHoraireIncoherenceGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateurHoraireIncoherenceGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FormateurHoraireIncoherenceGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FormateurHoraireIncoherenceGridDtoPaginatedResultsToJSON(value?: FormateurHoraireIncoherenceGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FormateurHoraireIncoherenceGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

